import { useNavigate } from 'react-router';
import { Center, Paper, Title, TextInput, PasswordInput, Button, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { trpc } from '../lib/trpc';
import { useAuth } from '../lib/auth';

export default function SignIn() {
  const navigate = useNavigate();
  const { refetch } = useAuth();

  const form = useForm({
    initialValues: { username: '', password: '' },
    validate: {
      username: (v) => (v ? null : 'Required'),
      password: (v) => (v ? null : 'Required'),
    },
  });

  const signIn = trpc.admin.auth.signIn.useMutation({
    onSuccess: async () => {
      await refetch();
      navigate('/');
    },
    onError: (err) => notifications.show({ color: 'red', message: err.message }),
  });

  return (
    <Center h="100vh">
      <Paper withBorder p="lg" w={320}>
        <form onSubmit={form.onSubmit((values) => signIn.mutate({ ...values, rememberMe: true }))}>
          <Stack gap="md">
            <Title order={2}>Admin Sign In</Title>
            <TextInput label="Username" autoComplete="username" required {...form.getInputProps('username')} />
            <PasswordInput label="Password" autoComplete="current-password" required {...form.getInputProps('password')} />
            <Button type="submit" loading={signIn.isPending} fullWidth>Sign In</Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
